import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "electricFilled"
const ElectricFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.375 1.5C15.789 1.5 16.125 1.836 16.125 2.25V6H17.25C18.078 6 18.75 6.672 18.75 7.5V12.75C18.75 16.095 16.317 18.87 13.125 19.405V22.5H10.875V19.405C7.683 18.869 5.25 16.095 5.25 12.75V7.5C5.25 6.672 5.922 6 6.75 6H7.875V2.25C7.875 1.836 8.211 1.5 8.625 1.5S9.375 1.836 9.375 2.25V6H14.625V2.25C14.625 1.836 14.961 1.5 15.375 1.5" />
        </svg>
      }
    </span>
  )
}
export default ElectricFilledIcon
